export default {
    message: {
        type: null,
        message: null,
        showClose: true,
        center: false,
        isShowMessage: false
    },
    confirm: {
        type: 'info',
        message: null,
        callback: null,
        isShowConfirm: false
    }
};
